import { RouteObject } from 'react-router';

import { BannersContainer } from './containers/BannersContainer';
import { BannerCreateContainer } from './containers/BannerCreateContainer';
import { BannerEditContainer } from './containers/BannersEditContainer';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: 'banners',
        element: <BannersContainer />,
    },
];

export const bannerExtraRoutes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/banners/create`,
        element: <BannerCreateContainer />,
    },
    {
        path: `${SHOP_CURRENT_ROUTE}/banners/edit/:bannerId`,
        element: <BannerEditContainer />,
    },
];

export default routes;
